import { Cycle } from 'types/Cycle';
import { useGlobalState } from 'features/appBootstrap/globalStateInitialisation/GlobalState';
import { useCycles } from 'utils/hooks/globalState/useCycles';

export const useSelectedCycle = (): Cycle | null => {
  const [state] = useGlobalState();
  return state.selectedCycle;
};

export const useIsCyclePinned = (): boolean => {
  const [state] = useGlobalState();
  return state.isCyclePinned;
};

export const useSetSelectedCycle = () => {
  const [, setState] = useGlobalState();
  const setSelectedCycle = (cycle: Cycle) =>
    setState(state => ({
      ...state,
      selectedCycle: cycle,
      isCyclePinned: true,
    }));
  return setSelectedCycle;
};

export const useSetSelectedCycleById = () => {
  const cycles = useCycles();
  const [, setState] = useGlobalState();
  const setSelectedCycleById = (id: Cycle['id'], { pin = true } = {}) => {
    const cycle = cycles.find(c => c.id === id);
    if (cycle) {
      setState(state => ({
        ...state,
        selectedCycle: cycle,
        // A pinned cycle stays pinned through programmatic sets (pin: false).
        isCyclePinned: state.isCyclePinned || pin,
      }));
    }
  };
  return setSelectedCycleById;
};
